// English
export default {
  common: {
    confirm: 'OK',
    submit: 'Submit',
    search: 'Search',
    loadMore: 'Load More',
    loading: 'Loading...',
    cancel: 'Cancel',
    back: 'Back',
    noData: 'No data',
    copy: 'Copy',
    copied: 'Copied',
    copyFailed: 'Copy failed',
  },
  lang: {
    label: 'Language',
    es: 'Español',
    zh: '中文',
    en: 'English',
  },
  tabbar: {
    home: 'HOME',
    query: 'QUERY',
    info: 'ORDERS',
    my: 'Me',
  },
  login: {
    user: 'Username',
    userPlaceholder: 'Enter 8-digit phone number',
    password: 'Password',
    passwordPlaceholder: 'Password',
    submit: 'SIGN IN',
    createAccount: 'CREATE ACCOUNT',
      userMustBe8Digits: 'Account must be 8 digits',
},
  register: {
    user: 'Username',
    userPlaceholder: 'Enter 8-digit phone number',
    password: 'Password',
    passwordPlaceholder: 'Password',
    confirmPassword: 'Confirm Password',
    confirmPasswordPlaceholder: 'Confirm Password',
    confirmPasswordRequired: 'CONFIRM PASSWORD',
    name: 'Name',
    namePlaceholder: 'Name',
    sinpe: 'SINPE Mobile',
    sinpePlaceholder: 'SINPE Mobile',
    sinpeRequired: 'Mobile',
    submit: 'SIGN UP',
    submitting: 'Submitting...',
    backToLogin: 'Back to login page',
    passwordMismatch: 'The two passwords are inconsistent',
    success: 'Registration successful',
    fail: 'Registration failed',
      userMustBe8Digits: 'Account must be 8 digits',
},
  home: {
    noLottery: 'No lotteries available',
    paga: 'PAYS',
    saldo: 'BALANCE',
    monto: 'Amount',
    rMonto: 'R Amount',
    total: 'Total',
    reventados: 'REVENTADOS',
    colNum: 'No.',
    colAmount: '₡',
    colReve: 'Reve',
    colSorteo: 'Draw',
    betList: 'Bet list',
    order: 'ORDER',
    orderSuccess: 'Order placed successfully',
    orderFail: 'Failed to place order',
    selectLottery: 'Please select a lottery to order',
    enterAmountRight: 'Enter the amount on the right',
    selectNumAndAmount: 'Select lottery numbers and amount',
    selectNum: 'Select lottery numbers',
    changeProductTitle: 'Are you sure you want to change the product?',
    changeProductMessage:
      'A lottery is currently selected. If you change it, the previous selection will be lost.',
    sorteo: 'Draw',
  },
  successOrder: {
    title: 'Print',
    validFor: 'VALID ONLY FOR:',
    mobile: 'Mobile:',
    date: 'DATE:',
    invoice: 'INVOICE:',
    paga: 'PAYS:',
    colNum: 'No.',
    colAmount: '₡',
    colReve: 'Reve',
    total: 'TOTAL:',
    note1: '** YOU HAVE 7 DAYS TO CLAIM **',
    note2: '** CHECK BEFORE PAYING **',
    note3: '** NO CLAIMS ACCEPTED **',
    note4: '** NO TICKET, NO PAYMENT **',
    sellerSign: 'SELLER SIGNATURE:__________________',
    thanks: 'Thank you for betting',
    print: 'Print',
      continueOrder: 'Continue betting',
    sendWhatsApp: 'Send via WhatsApp',
},
  order: {
    listTitle: 'Order information',
    detailTitle: 'Order details',
    status: 'Status:',
    statusValid: 'Valid',
    orderNo: 'Order No.:',
    colNum: 'No.',
    colAmount: '₡',
    colReve: 'Reve',
  },
  query: {
    winningTab: 'Winning Query',
    rechargeTab: 'Recharge Query',
    withdrawTab: 'Withdrawal Query',
    startTime: 'Start Time',
    startTimePlaceholder: 'Click to select time',
    endTime: 'End Time',
    endTimePlaceholder: 'Start Time',
    pickerTitle: 'Select year, month and day',
    time: 'Time:',
    rechargeAmount: 'Recharge amount:',
    withdrawAmount: 'Withdrawal amount:',
    sorteo: 'Draw:',
    lottery: 'Lottery:',
    number: 'Number:',
    amount: 'Amount:',
    pendingRecharges: 'Pending recharges',
  },
  my: {
    account: 'Account:',
    balance: 'Balance:',
    withdrawing: 'Withdrawing:',
    recharge: 'Recharge',
    withdraw: 'Withdraw',
    changePassword: 'Change password',
    messageCenter: 'Message Center',
    logout: 'LOG OUT',
  },
  recharge: {
    title: 'Recharge',
    method: 'Transfer method',
    methodPlaceholder: 'Click to select recharge method',
    methodRequired: 'Please select a payment method',
    amount: 'Recharge amount',
    amountPlaceholder: 'Please enter the recharge amount',
    minAmount: 'The recharge amount must be greater than 100',
      arrivedTitle: 'Recharge received',
    arrivedHint: 'Your account has received a recharge',
    newBalance: 'Current balance',
    sinpeNoticeTitle: 'Important: Required',
    sinpeNoticeBody: 'When transferring, you MUST enter your account phone number in the SINPE Móvil "Descripción (opcional)" field. Otherwise the credit may not be automatic and will require manual review, delaying processing.',
    sinpeNoticeTail: 'Example: put your phone in the description ↑',
    paymentInfo: 'Payment info',
    accountNo: 'Recipient account',
    yourMobile: 'Your phone',
    submittedTitle: 'Recharge request submitted',
    submittedHint: 'Open your bank app to transfer. You can switch back here anytime to copy the info:',
    sinpeReminder: "Don't forget to put your phone number in the SINPE Descripción field, or the credit may not be automatic",
    gotIt: 'Got it',
    accountName: 'Recipient',
    orderId: 'Order ID',
    pendingTitle: 'Pending recharge',
    viewInfo: 'View info',
  },
  withdraw: {
    title: 'Withdraw',
    amount: 'Amount',
    amountPlaceholder: 'Please enter the amount you want to withdraw',
    minAmount: 'The withdrawal amount must be greater than 100.',
    success: 'Withdrawal request successful, please wait for SINPE',
      completedTitle: 'Withdrawal processed',
    completedHint: 'Your withdrawal request has been processed',
},
  message: {
    title: 'Message Center',
    newMessage: 'New message',
    newMessageText: 'You have a new message about: {title}',
  },
  changePassword: {
    title: 'Change password',
    oldPassword: 'Old password',
    oldPasswordPlaceholder: 'Please enter the old password',
    password: 'Password',
    passwordPlaceholder: 'New password',
    confirmPassword: 'Confirm Password',
    confirmPasswordPlaceholder: 'New password again',
    passwordMismatch: 'The two passwords are inconsistent, please re-enter',
  },
  setting: {
    title: 'Settings',
    changeAvatar: 'Change image',
    changePassword: 'Change password',
    changePrint: 'Change print parameters',
    avatarTitle: 'Change avatar',
    printTitle: 'Change print template',
    selectFirst: 'Please select before submitting',
  },
  routeTitle: {
    Home: 'Home',
    Query: 'Query',
    Order: 'Order information',
    OrderDetail: 'Order details',
    My: 'Me',
    Setting: 'Settings',
    Avatar: 'Upload avatar',
    ChangePassword: 'Change password',
    PrintTemplate: 'Change print template',
    Recharge: 'Recharge center',
    Message: 'Message center',
    Withdraw: 'Withdrawal center',
    SuccessOrder: 'Order details',
    login: 'Login',
    register: 'Register',
  },
};
